// import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

import {
  Switch,
  Select,
  Button,
  Icon,
  Popover,
} from 'ant-design-vue'

export default {
  install(Vue) {
    // Vue.use(Antd)
    Vue.use(Switch)
    Vue.use(Select)
    Vue.use(Button)
    Vue.use(Icon)
    Vue.use(Popover)
  },
}
